import React, { ReactElement } from 'react';
import { BUTTON_ICON_ICON_NAME, BUTTON_ICON_STYLE_TYPE, ButtonIcon } from 'b2b-components/theme/components/ButtonIcon';
import { Modal, MODAL_ANIMATION_TYPE, MODAL_CLOSE_BUTTON, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ComponentType, Props } from './PDFAction.types';
import { PDFForm as PDFFormComponent } from './PDFForm';

const PDFAction: ComponentType = ({
  hasUserPdfExportPermissions,
  isLoggedIn,
  isModalOpened,
  isPrivate,
  product,
  toggleModal,
}: Props): ReactElement | null => {
  const t = useTranslate();
  if (!isLoggedIn || !hasUserPdfExportPermissions || isPrivate) {
    return null;
  }

  const PDFForm = () => (
    <PDFFormComponent product={product} toggleModal={toggleModal} />
  );

  return (
    <>
      <ButtonIcon
        icon={BUTTON_ICON_ICON_NAME.pdf}
        styleType={BUTTON_ICON_STYLE_TYPE.secondary}
        onClick={toggleModal}
      />
      <Modal
        text={{
          ariaLabel: t('PDF Export'),
          ariaCloseModal: t('Close PDF Modal'),
        }}
        isOpen={isModalOpened}
        animationType={MODAL_ANIMATION_TYPE.fade}
        closeButton={MODAL_CLOSE_BUTTON.right}
        type={MODAL_TYPE.default}
        content={PDFForm}
        onCloseModal={toggleModal}
      />
    </>
  );
};

export { PDFAction };
